var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wallet-passes-app 1",
    clipPath: "url(#clip0_2451_41903)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.0611 6.61196C23.5788 6.61196 23.9985 6.1923 23.9985 5.6746V4.69037C23.9985 2.10409 21.8943 0 19.308 0C19.308 0 4.61454 0.0022028 4.57831 0.00646779C3.34151 0.0496801 2.15345 0.580414 1.29708 1.47775C0.419286 2.39749 -0.0383332 3.59375 0.00473849 4.85239C0.0029575 4.87625 0.00202014 18.3723 0.00202014 18.3723C0.00202014 21.4754 2.52661 24 5.62975 24H19.3081C21.8944 24 23.9985 21.8959 23.9985 19.3096V12.1928C23.9985 9.60654 21.8944 7.50245 19.3081 7.50245H4.68878C3.1838 7.50245 1.94995 6.32616 1.87979 4.8245C1.84412 4.06093 2.11882 3.33204 2.6532 2.77206C3.19533 2.20402 3.9567 1.87828 4.74202 1.87828C4.76972 1.87828 19.308 1.87472 19.308 1.87472C20.8605 1.87472 22.1236 3.13782 22.1236 4.69037V5.6746C22.1237 6.1923 22.5434 6.61196 23.0611 6.61196ZM4.68878 9.37717H19.308C20.8606 9.37717 22.1237 10.6403 22.1237 12.1928V19.3096C22.1237 20.8622 20.8606 22.1253 19.308 22.1253H5.62975C3.56034 22.1253 1.87674 20.4417 1.87674 18.3723V8.44361C2.66075 9.03086 3.6349 9.37717 4.68878 9.37717ZM20.249 15.7512C20.249 16.3983 19.7244 16.9229 19.0773 16.9229C17.5231 16.8612 17.5235 14.641 19.0773 14.5795C19.7244 14.5795 20.249 15.1041 20.249 15.7512ZM20.249 4.69037C20.249 4.17266 19.8294 3.75301 19.3117 3.75301H4.68882C3.44513 3.8025 3.44607 5.57866 4.68882 5.62773H19.3117C19.8293 5.62773 20.249 5.20807 20.249 4.69037Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2451_41903"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/wallet_icon.63a1564b8e203643e4bda6f64892f534.svg";
export { ForwardRef as ReactComponent };